export async function maybeStartMocks(environment) {
	if (environment === 'development' && !process.env.VITE_PLAYWRIGHT) {
		const { worker } = await import('../mocks/browser');
		return worker.start();
	}

	return Promise.resolve();
};
